<script>
import FrameBlue from '~/src/components/ui/Frame/FrameBlue';

export default {
    name: 'ProductAvailableOnlyInStore',
    functional: true,
    render(h, { props: { bemModifiers } }) {
        const text = 'Produkt dostępny wyłącznie w sprzedaży stacjonarnej';
        return h(FrameBlue, {
            props: {
                bemModifiers,
            },
        }, text);
    },
};
</script>
